import { useFirestore } from "../../../firebase/useFirestore";
import ToggleButton from "../../common/ToggleButton";

/**
 * Zet de verwijderkolom van het huishoudenoverzicht vast aan de rechterkant.
 *
 * Staat uit tenzij een organisatie hem aanzet: met een handvol kolommen blijft
 * de knop vanzelf in beeld, en een kolom die over de tabel heen ligt is dan
 * alleen maar in de weg. Bij veel eigen kolommen scrollt hij wél weg — dat is
 * de reden dat deze schakelaar bestaat (verzoek Duurzame Vecht).
 */
const StickyDeleteColumn = () => {
    const compagny = useFirestore("CompagnyMeta");

    return (
        <div className="dashboard-container">
            <h2>Verwijderknop vastzetten</h2>
            <p>
                Zet aan om de kolom 'VERWIJDEREN' in het overzicht van huishoudens
                aan de rechterkant vast te zetten. Hij blijft dan in beeld als je
                naar rechts scrollt. Handig als je veel kolommen aan hebt staan.
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>Verwijderknop in beeld houden</p>
                    <ToggleButton
                        docid={comp.docid}
                        id={"StickyDeleteColumn"}
                        collection={"CompagnyMeta"}
                        value={comp.StickyDeleteColumn}
                    />
                </div>
            ))}
        </div>
    );
};

export default StickyDeleteColumn;
